import styled, { css } from 'styled-components';
import { Radio as AntdRadio } from 'antd';
import { theme } from '../../theme';

type RadioTabProps = {
  $size?: keyof typeof theme.styles.height;
};

const RADIO_TAB_COMMON_CSS = css<RadioTabProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  height: ${({ theme, $size = 'medium' }) => theme.styles.height[$size]};

  span.ant-radio {
    display: none;
  }
`;

export const Radio = styled(AntdRadio)<RadioTabProps>`
  ${RADIO_TAB_COMMON_CSS}

  border-radius: 12px;
  padding: 0px 18px;
  border: solid 1px ${theme.colors.yellow60};

  &.ant-radio-wrapper {
    background: ${({ theme }) => theme.colors.white};
    margin-right: 0;
  }

  &.ant-radio-wrapper-checked {
    background: ${({ theme }) => theme.colors.yellow60};
    span {
      color: ${({ theme }) => theme.colors.black};
    }
  }
  & > span {
    color: ${({ theme }) => theme.colors.black};
    font-weight: 600;
    font-size: 15px;
  }

  &.ant-radio-wrapper-checked.ant-radio-wrapper-disabled {
    background: ${({ theme }) => theme.colors.grey10};
    span {
      color: ${({ theme }) => theme.colors.grey30};
    }
  }
`;

export const RadioTab = styled(AntdRadio)<RadioTabProps>`
  ${RADIO_TAB_COMMON_CSS}

  border-radius: unset;
  padding: 0px 0px 5px 0px;
  margin: 0px 12px;
  border-bottom: solid 2px transparent;

  &.ant-radio-wrapper {
    background: transparent;
  }

  &.ant-radio-wrapper-checked {
    background: transparent;
    border-bottom: solid 2px ${({ theme }) => theme.colors.yellow60};
    span {
      color: ${({ theme }) => theme.colors.grey100};
    }
  }

  &.ant-radio-wrapper:hover > span {
    color: ${({ theme }) => theme.colors.grey100};
  }

  & > span {
    color: ${({ theme }) => theme.colors.grey70};
    font-weight: 600;
    font-size: 15px;
    padding: 0px;
  }
`;

export const RadioGroup = styled(Radio.Group)<{
  $clip?: 'start' | 'end';
}>`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 6px 4px;

  & > .ant-radio-wrapper:first-child {
    ${({ $clip }) =>
      $clip === 'start' &&
      css`
        margin-left: 0px;
      `};
  }

  & > .ant-radio-wrapper:last-child {
    ${({ $clip }) =>
      $clip === 'end' &&
      css`
        margin-right: 0px;
      `};
  }
`;
